export default class MoveInDate {
  static get OneToTwoMonths() {
    return this.getInstance('1-2');
  }

  static get ThreeToSixMonths() {
    return this.getInstance('3-6');
  }

  static get BuildablePlans() {
    return this.getInstance(null);
  }

  static fromKey(key) {
    const moveInDateMap = {
      '1-2': MoveInDate.OneToTwoMonths,
      '3-6': MoveInDate.ThreeToSixMonths,
      null: MoveInDate.BuildablePlans,
    };

    return moveInDateMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new MoveInDate(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(MoveInDate, 'instances', { value: {} });